<div class="container">
	<app-intro [usedAsEntryComponent]="true" (endIntroEvent)="onClose()"></app-intro>
</div>
